import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ShelfType } from '../../services/books.service';
import { fadeIn, fadeInOut } from '../../utils/animations';
import { HeaderComponent } from '../../components/header/header.component';
import { SearchComponent } from '../../components/search/search.component';
import { BookShelfDrawerComponent } from '../../components/book-shelf/book-shelf-drawer/book-shelf-drawer.component';
import { BookCategoriesShelvesComponent } from '../../components/book-categories-shelves/book-categories-shelves.component';
import { IonContent } from '@ionic/angular/standalone';
import { AsyncPipe } from '@angular/common';
import { BookFiltersBtnComponent } from '../../components/book-filters-btn/book-filters-btn.component';
import { BookCategoriesBtnComponent } from '../../components/book-categories-btn/book-categories-btn.component';
import { UserState } from '../../store/user.state';
import { NativeAppInstallationBannerComponent } from '../../components/native-app-installation-prompt/native-app-installation-banner.page';
import { ProductTourService } from '../../services/product-tour.service';
import { ProductTourSproutyComponent } from '../../components/product-tour/product-tour-sprouty/product-tour-sprouty.component';
import { delay, Subject, takeUntil } from 'rxjs';
import { FlagsState } from '../../store/flags.state';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrl: './home.page.scss',
  animations: [fadeInOut, fadeIn],
  imports: [
    HeaderComponent,
    SearchComponent,
    BookShelfDrawerComponent,
    BookCategoriesShelvesComponent,
    IonContent,
    AsyncPipe,
    BookFiltersBtnComponent,
    BookCategoriesBtnComponent,
    NativeAppInstallationBannerComponent,
    ProductTourSproutyComponent,
  ],
})
export class HomePage implements OnInit, OnDestroy {
  constructor(
    public userState: UserState,
    public productTourService: ProductTourService,
    private flagsState: FlagsState,
  ) {}

  isSearchFocused = false;

  protected readonly shelfType = ShelfType;
  private destroyed$ = new Subject<void>();

  ngOnInit(): void {
    // Delay is needed to be sure the dom is being updated in order to calculate the position of the carret
    this.flagsState.flags$.pipe(takeUntil(this.destroyed$), delay(150)).subscribe(flags => {
      if (!flags.walkthroughCompletedOrDismissed) {
        void this.productTourService.startTour();
      }
    });
  }

  searchFocused(focused: boolean): void {
    this.isSearchFocused = focused;
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
